import { MessageCircle } from "lucide-react";
import { useContact } from "@/context/ContactContext";
import { trackEvent } from "@/lib/analytics";

export const WhatsAppButton = () => {
  const contact = useContact();
  const number = (contact.whatsapp || contact.phone || "").replace(/[^0-9]/g, "");
  const href = number
    ? `https://wa.me/${number}?text=${encodeURIComponent("Hi WAAN METAL, I would like to enquire about your services.")}`
    : "/request-quotation";
  const isWa = Boolean(number);

  return (
    <a
      href={href}
      target={isWa ? "_blank" : undefined}
      rel={isWa ? "noopener noreferrer" : undefined}
      onClick={() => trackEvent("whatsapp_click", { source: "float_button" })}
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 px-4 py-3 rounded-full bg-[#25D366] text-white font-semibold shadow-xl shadow-black/20 hover:scale-105 transition-transform"
      aria-label="WhatsApp Us"
    >
      <MessageCircle size={22} />
      <span className="hidden sm:inline text-sm">WhatsApp Us</span>
    </a>
  );
};
